/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.BusinessReviewSession = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The BusinessReviewSession model module.
   * @module model/BusinessReviewSession
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>BusinessReviewSession</code>.
   * @alias module:model/BusinessReviewSession
   * @class
   */
  var exports = function() {
    var _this = this;












  };

  /**
   * Constructs a <code>BusinessReviewSession</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/BusinessReviewSession} obj Optional instance to populate.
   * @return {module:model/BusinessReviewSession} The populated <code>BusinessReviewSession</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('ScheduleID')) {
        obj['ScheduleID'] = ApiClient.convertToType(data['ScheduleID'], 'Integer');
      }
      if (data.hasOwnProperty('TemplateID')) {
        obj['TemplateID'] = ApiClient.convertToType(data['TemplateID'], 'Integer');
      }
      if (data.hasOwnProperty('TargetUserID')) {
        obj['TargetUserID'] = ApiClient.convertToType(data['TargetUserID'], 'Integer');
      }
      if (data.hasOwnProperty('InvitationDate')) {
        obj['InvitationDate'] = ApiClient.convertToType(data['InvitationDate'], 'Date');
      }
      if (data.hasOwnProperty('DueDate')) {
        obj['DueDate'] = ApiClient.convertToType(data['DueDate'], 'Date');
      }
      if (data.hasOwnProperty('DateStarted')) {
        obj['DateStarted'] = ApiClient.convertToType(data['DateStarted'], 'Date');
      }
      if (data.hasOwnProperty('DateClosed')) {
        obj['DateClosed'] = ApiClient.convertToType(data['DateClosed'], 'Date');
      }
      if (data.hasOwnProperty('Comment')) {
        obj['Comment'] = ApiClient.convertToType(data['Comment'], 'String');
      }
      if (data.hasOwnProperty('StatusID')) {
        obj['StatusID'] = ApiClient.convertToType(data['StatusID'], 'Integer');
      }
      if (data.hasOwnProperty('SessionEndStatusID')) {
        obj['SessionEndStatusID'] = ApiClient.convertToType(data['SessionEndStatusID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} ScheduleID
   * @default 0
   */
  exports.prototype['ScheduleID'] = 0;
  /**
   * @member {Integer} TemplateID
   * @default 0
   */
  exports.prototype['TemplateID'] = 0;
  /**
   * @member {Integer} TargetUserID
   * @default 0
   */
  exports.prototype['TargetUserID'] = 0;
  /**
   * @member {Date} InvitationDate
   */
  exports.prototype['InvitationDate'] = undefined;
  /**
   * @member {Date} DueDate
   */
  exports.prototype['DueDate'] = undefined;
  /**
   * @member {Date} DateStarted
   */
  exports.prototype['DateStarted'] = undefined;
  /**
   * @member {Date} DateClosed
   */
  exports.prototype['DateClosed'] = undefined;
  /**
   * @member {String} Comment
   * @default ''
   */
  exports.prototype['Comment'] = '';
  /**
   * @member {Integer} StatusID
   * @default 0
   */
  exports.prototype['StatusID'] = 0;
  /**
   * @member {Integer} SessionEndStatusID
   */
  exports.prototype['SessionEndStatusID'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


